export { default } from './TicketTypeView';
